import { IonPage } from '@ionic/react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { useGetOrderDetails } from '@apps-common/apis/portal/orders/get-order-details'
import { OrderDetailsCard } from '@apps-common/apps/portal/pages/orders/pages/details/components'
import {
  ManagementOrderDetailsComplete,
  ManagementOrderDetailsOptions,
  ManagementOrderUnits
} from '@apps-common/apps/portal/pages/orders/pages/details/components/management'
import { PortalOrderUnits } from '@apps-common/apps/portal/pages/orders/pages/details/components/portal'
import { PullRefresh } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { ROUTE_ORDER_DETAILS } from '@apps-radionet-portal/config/private-routes'

export const OrderDetailsPage: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>()
  const [childIsUpdating, setChildIsUpdating] = useState<boolean>(false)

  const {
    data,
    isLoading: orderIsLoading,
    isError: orderIsError,
    isRefetching: orderIsRefetching,
    refetch: orderRefetch
  } = useGetOrderDetails({
    config: {
      enabled: orderId !== undefined
    },
    id: orderId
  })

  console.log('order', data)

  const { order } = data || {}

  const { status } = order || {}

  const loading = orderIsLoading || orderIsError
  const updating = childIsUpdating

  return (
    <IonPage>
      <Header>
        <Navbar showBack transparent icons={[]} />
        <Breadcrumbs route={ROUTE_ORDER_DETAILS} />
        <div className='flex items-center justify-between'>
          <PageTitle>{ROUTE_ORDER_DETAILS.label}</PageTitle>
          <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes}>
            <div className='relative flex items-center justify-end gap-[5px]'>
              <ManagementOrderDetailsOptions
                loading={loading}
                updating={updating}
                status={status}
                orderId={orderId}
                isUpdatingCallback={(value) => setChildIsUpdating(value)}
              />
            </div>
          </Authorization>
        </div>
      </Header>
      <LayoutContainer>
        <PullRefresh loading={orderIsRefetching} callback={() => orderRefetch()} />
        <LayoutPadding>
          <div className='grid grid-cols-1 gap-[20px]'>
            <div className='relative grid lg:grid-cols-2 gap-[20px] overflow-hidden pb-[5px]'>
              <OrderDetailsCard data={data} loading={loading} updating={updating} classes='grow' />
              <div className='relative w-full'>
                <Authorization
                  roles={AUTH_CLAIMS.managementAdmin.roles}
                  scopes={AUTH_CLAIMS.managementAdmin.scopes}
                  notAuthorizedFallback={<PortalOrderUnits data={data} loading={loading} updating={updating} classes='lg:w-full' />}
                >
                  <ManagementOrderUnits data={data} loading={loading} updating={updating} classes='lg:w-full' />
                </Authorization>
              </div>
            </div>
            <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes}>
              <ManagementOrderDetailsComplete
                loading={loading}
                updating={updating}
                orderId={orderId}
                isUpdatingCallback={(value) => setChildIsUpdating(value)}
              />
            </Authorization>
          </div>
        </LayoutPadding>
      </LayoutContainer>
    </IonPage>
  )
}
